import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { siteDisclaimers } from '../content/disclaimers';

const Disclaimers: React.FC = () => {
  return (
    <LegalLayout>
      <article className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
        <h1 className="text-3xl md:text-4xl font-bold text-text-dark mb-8">
          Disclaimers
        </h1>

        <div className="space-y-10 text-text-light">
          {siteDisclaimers.map((item) => (
            <section key={item.id} aria-labelledby={`disclaimer-${item.id}`}>
              <h2
                id={`disclaimer-${item.id}`}
                className="text-xl font-bold text-text-dark mb-4"
              >
                {item.title}
              </h2>
              <p className="mb-4">{item.body}</p>
              <p className="font-semibold text-text-dark">
                {item.emphasisTitle ? (
                  <>
                    {item.emphasisTitle} {item.emphasis}
                  </>
                ) : (
                  item.emphasis
                )}
              </p>
            </section>
          ))}
        </div>
      </article>
    </LegalLayout>
  );
};

export default Disclaimers;
